import gql from 'graphql-tag'

export default gql`
  mutation UserUpdate($id: ID!, $email: String!, $directAccessCourseIds: [ID!]) {
    userUpdate(id: $id, email: $email, directAccessCourseIds: $directAccessCourseIds) {
      id
    }
  }
`
